module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter1",
    attrs: {
      "id": "atn"
    }
  }, [_vm._v("AUTHOR’S NOTE")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("In this novel I have made certain assumptions about the maximum size of various marine animals which may be challenged by some biologists. I do not think, however, that they will meet much criticism from underwater explorers, who have often encountered fish "), _c('em', [_vm._v("several times")]), _vm._v(" the size of the largest recorded specimens.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For an account of Heron Island as it is today, seventy-five years before the opening of this story, I refer the reader to "), _c('em', [_vm._v("The Coast of Coral")]), _vm._v(", and I hope that the University of Queensland will appreciate my slight extrapolation of its existing facilities.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3caac4f7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780795325090_epub_atn_r1.vue
// module id = 72
// module chunks = 0